module.exports = __webpack_public_path__ + "img/logo-light.28862b8a.png";